import React, { Component } from 'react'
import { connect } from 'react-redux'
import MultiComplete from '../../Wizard2/fieldComponents/MultiComplete'

class FieldSrcSelect extends Component {
    handleChange = (e) => {
      this.props.onChange(this.props.name, e.target.value)
    }

    render() {
      const {
        options,
        emptyOptionLabel = '[Select an Option]',
        value,
        emptyOptionValue = '',
        type,
        selectedOptionExists,
      } = this.props

      return type === 'MultiComplete' ? (
        <MultiComplete
          onChange={(v) => this.props.onChange(this.props.name, v)}
          options={options}
          value={value}
        />
      ) : (
        <select onChange={this.handleChange} value={value}>
          {!selectedOptionExists ? (
            <option value={value}>[Selected Field Is Not Valid]</option>
          ) : null}
          <option value={emptyOptionValue}>{emptyOptionLabel}</option>
          {options.map((option, i) => {
            return (
              <option value={option.value} key={i}>
                {option.label}
              </option>
            )
          })}
        </select>
      )
    }
  }

FieldSrcSelect = connect((state, props) => {
    const {
      props: { excludeSelf, allowedTypes = [] } = {},
      parentField = {},
      excludeSelf: secondExcludeSelf,
      parentFieldId,
    } = props
    let options = Object.keys(state.designer.wizard.fields).map((fieldId) => {
      const label = state.designer.wizard.fields[fieldId].label
      const name = state.designer.wizard.fields[fieldId].name
      return {
        value: fieldId,
        label:
          label !== '' && label ? (label.length > 50 ? label.substring(0, 50) + '...' : label) : name,
      }
    })
    if (props.limitToRepeaterSiblings) {
      const parent = state.designer.wizard.fields[props.parentField.parent.id]
      options = options.filter((opt) => parent.template.includes(opt.value))
    }
    if (excludeSelf || secondExcludeSelf) {
      options = options.filter((opt) => opt.value !== (parentFieldId || parentField.fieldId))
    }
    if (allowedTypes.length) {
      options = options.filter((opt) => {
        const type = state.designer.wizard.fields[opt.value].type
        return allowedTypes.includes(type)
      })
    }
    return {
      options,
      selectedOptionExists: props.value ? !!options.find((opt) => opt.value === props.value) : true,
    }
  })(FieldSrcSelect)


export default FieldSrcSelect;